// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonToggleGroupLarge = 8;
var ButtonToggleGroupMedium = 8;
var ButtonToggleGroupSmall = 8;
var ButtonDefault = 8;
var CardDefault = 12;
var FieldsInputDefault = 8;
var FieldsInputConnectedWrapperDefault = 8;
var ModalDefault = 12;
var PaginationDefault = 4;
var PopoverContainerDefault = 8;
var ToastContainer = 8;
var TooltipContainer = 8;
var BorderRadiusSemanticsAll = {
  ButtonDefault: ButtonDefault,
  ButtonToggleGroupLarge: ButtonToggleGroupLarge,
  ButtonToggleGroupMedium: ButtonToggleGroupMedium,
  ButtonToggleGroupSmall: ButtonToggleGroupSmall,
  CardDefault: CardDefault,
  FieldsInputConnectedWrapperDefault: FieldsInputConnectedWrapperDefault,
  FieldsInputDefault: FieldsInputDefault,
  ModalDefault: ModalDefault,
  PaginationDefault: PaginationDefault,
  PopoverContainerDefault: PopoverContainerDefault,
  ToastContainer: ToastContainer,
  TooltipContainer: TooltipContainer
};

export { BorderRadiusSemanticsAll, ButtonDefault, ButtonToggleGroupLarge, ButtonToggleGroupMedium, ButtonToggleGroupSmall, CardDefault, FieldsInputConnectedWrapperDefault, FieldsInputDefault, ModalDefault, PaginationDefault, PopoverContainerDefault, ToastContainer, TooltipContainer, BorderRadiusSemanticsAll as default };
